import { CoreState, coreFeatureName } from './core.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectCoreState = createFeatureSelector<CoreState>(coreFeatureName);

export const selectIdentityState = createSelector(
  selectCoreState,
  (state: CoreState) => state.identity
);
